import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { computerScienceEnggData } from '../../data/departmentalData/computerScienceEngg';

const ComputerScienceEngg = () => {
  return <TemplatePage data={computerScienceEnggData} />;
};

export default ComputerScienceEngg;
